import Carousel from 'bootstrap/js/dist/carousel.js';

export const init = () => {
	load();

	normalization();
}

const load = () => {
	const carousel = $('.carousel');

	carousel.carousel();

	let isLeaving = false;

	let observer = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				isLeaving = true;

				carousel.carousel('cycle');
			} else if (isLeaving) {
				isLeaving = false;

				carousel.carousel('pause');
			}
		});
	});

	$.each(carousel, (index, element) => observer.observe(element));
}

const normalization = () => {
	const items = $('.carousel .carousel-item');

	let heights = [];

	let tallest;

	const normalizeHeights = () => {
		items.each(function () {
			heights.push($(this).height());
		});

		tallest = Math.max.apply(null, heights);

		items.each(function () {
			$(this).css('min-height', tallest + 'px');
		});
	}

	if (items.length) {
		normalizeHeights();

		$(window).on('resize orientationchange', () => {
			window.requestAnimationFrame(() => {
				tallest = 0, heights.length = 0; //reset vars

				items.each(function () {
					$(this).css('min-height', '0'); //reset min-height
				});

				normalizeHeights();
			});
		});
	}
}